<template>
  <div>
    <v-layout v-if="filteredSustainabilityList.length > 0" row wrap>
      <v-flex xs12>
        <v-container class="pa-5" bg fill-height grid-list-md text-xs-center>
          <v-layout row wrap align-center>
            <v-flex>
              <v-card color="transparent" flat class="mx-auto">
                <h1
      
                  :style="`color: #4dc8ed; text-align:${
                    $vuetify.breakpoint.mdAndUp ? 'left' : 'center'
                  }`"
                >
                  {{ filteredSustainabilityList[this.tab].title }}
                </h1>
                <v-layout class="mt-4" row wrap align-center>
                  <v-flex xs12 md2 sm2>
                    <transition name="fade" mode="out-in">
                      <div :key="tab">
                        <v-img
                          class="mx-auto"
                          :src="filteredSustainabilityList[this.tab].imgUrl"
                          max-width="150"
                        >
                        </v-img>
                      </div>
                    </transition>
                  </v-flex>
                  <v-flex xs12 md10 sm10>
                    <transition name="fade" mode="out-in">
                      <div
                        :style="`text-align: ${
                          $vuetify.breakpoint.xs ? 'center' : 'left'
                        }`"
                        :key="tab"
                      >
                        <p
                          class="pl-2"
                          style="
                            word-wrap: break-word;
                            line-height: 1.5;
                            color: white;
                          "
                        >
                          {{ filteredSustainabilityList[this.tab].notes }}
                        </p>
                      </div>
                    </transition></v-flex
                  >
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs12>
        <v-layout class="pa-5" row wrap>
          <v-flex
            v-for="(susItem, index) in filteredSustainabilityList"
            :key="index"
            xl1
            lg2
            md3
            sm2
            xs3
          >
            <div
              style="border-radius: 90%; width: 40px"
              v-ripple
              @click="susItemClick(index)"
            >
              <v-img
                :style="`filter: grayscale(${susItem.isActivated ? 0 : 1});`"
                :src="susItem.imgUrl"
                max-width="40"
              >
              </v-img>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    supplierSustainabilityList: {
      type: Array,
      default: () => [],
    },
  },

  watch: {
    supplierSustainabilityList: {
      deep: true,
      immediate: true,
      handler() {
        this.initialiseSustainabilityList();
      },
    },
  },
  destroyed() {
    clearInterval(this.tabInterval);
  },
  methods: {
    startInterval() {
      clearInterval(this.tablInverval);
      if (this.filteredSustainabilityList.length > 0) {
        this.tabInterval = setInterval(() => {
          if (this.tab >= this.filteredSustainabilityList.length - 1) {
            this.filteredSustainabilityList[this.tab].isActivated = false;
            this.tab = 0;
            this.filteredSustainabilityList[this.tab].isActivated = true;
          } else {
            this.filteredSustainabilityList[this.tab].isActivated = false;
            this.tab = this.tab + 1;
            this.filteredSustainabilityList[this.tab].isActivated = true;
          }
        }, 8000);
      }
    },
    susItemClick(index) {
      this.filteredSustainabilityList[this.tab].isActivated = false;
      clearInterval(this.tabInterval);
      this.tab = index;
      this.filteredSustainabilityList[this.tab].isActivated = true;
    },
    initialiseSustainabilityList() {
      if (this.supplierSustainabilityList.length > 0) {
        for (let i = 0; i < this.sustainabilityList.length; i++) {
          let sustainabilityItem = this.sustainabilityList[i];
          this.supplierSustainabilityList.forEach((e) => {
            if (sustainabilityItem.field == e.field) {
              this.sustainabilityList[i].disabled = false;
              this.sustainabilityList[i].notes = e.notes;
            }
          });
        }
        for (let e of this.sustainabilityList) {
          if (!e.disabled) {
            e.isActivated = true;
            break;
          }
        }
        this.startInterval();
      }
    },
  },
  computed: {
    filteredSustainabilityList() {
      return this.sustainabilityList.filter((e) => !e.disabled);
    },
  },
  data: () => ({
    tabInterval: null,
    tab: 0,
    sustainabilityList: [
      {
        imgUrl:
          "https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/Outcomes/Sustainability+Icons-02.svg",
        title: "SME",
        field: "sustainabilitySME",
        notes:
          "Ruspec nulla accumsan. Mauris diam turpis, iaculis vitae ligposuere, accumsan consequat justo. Nunc dictum mauris sed",
        isActivated: false,
        disabled: true,
      },
      {
        imgUrl:
          "https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/Outcomes/Sustainability+Icons-34.svg",
        title: "Social Enterprise",
        field: "sustainabilitySocialEnterprise",
        notes:
          "Zsem tincidunt, vitae plac nulla accumsan. Mauris diam turpis, iaculis vitae ligposuere, accumsan consequat justo. Nunc dictum mauris sed",
        disabled: true,
      },
      {
        imgUrl:
          "https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/Outcomes/Sustainability+Icons-03.svg",
        title: "Carbon",
        field: "sustainabilityCarbon",
        isActivated: false,
        notes:
          "Suspendisse aliquam urna nec sem tincidunt, vitae plac nulla accumsan. Mauris diam turpis, iacuuere, accumsan consequat justo. Nunc dictum mauris sed",
        disabled: true,
      },
      {
        imgUrl:
          "https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/Outcomes/Sustainability+Icons-05.svg",
        title: "Waste",
        field: "sustainabilityWaste",
        isActivated: false,
        notes:
          "Suspendisse aliquam urna uris diam turpis, iaculis vitae ligposuere, accumsan consequat justo. Nunc dictum mauris sed",
        disabled: true,
      },
      {
        imgUrl:
          "https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/Outcomes/Sustainability+Icons-06.svg",
        title: "Water",
        field: "sustainabilityWater",
        isActivated: false,
        notes:
          "Suspendisse aliquam urna nec sem tincidunt, vitae plac nulla accumsan. Mauris diam turpis, iaculis vitae ligposuere, accumsan consequat justo. Nunc dictum mauris sed",
        disabled: true,
      },
      {
        imgUrl:
          "https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/Outcomes/Sustainability+Icons-07.svg",
        title: "Energy",
        field: "sustainabilityEnergy",
        isActivated: false,
        notes: "Hello What is your name",
        disabled: true,
      },
      {
        imgUrl:
          "https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/Outcomes/Sustainability+Icons-04.svg",
        title: "Social Impact",
        field: "sustainabilitySocialImpact",
        isActivated: false,
        notes:
          "Suspendisse aliquam urna nec sem tincidunt, vitae plac nulla accumsan. Mauris diam turpis, iaculis vitae ligposuere, accumsan consequat justo. Nunc dictum mauris sed",
        disabled: true,
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>